import type { BossFight } from '../../core/boss/boss-fight';
import { t } from '../../i18n/es';
import { bossBarModel } from './boss-bar-model';

/**
 * Boss health bar of the HUD (GDD §9.1, §13.3, issue #91): the boss nickname in display mono and a meter
 * (cr-art-ds-meter, role="meter", 0..1) under the route telemetry, never red. The fill moves in the 200 ms of
 * the meters (0 ms with reduced motion). Only the HP changes are announced. It touches the DOM on changes.
 */
export function bossHealthBar(): { element: HTMLElement; update(boss: BossFight | null): void } {
  const element = document.createElement('div');
  element.className = 'boss-bar';
  element.hidden = true;
  element.innerHTML = `
    <span class="display-mono" data-field="boss-name"></span>
    <cr-art-ds-meter class="telemetry boss-meter" role="meter" aria-label="${t('ui.hud.boss.label')}" aria-valuemin="0" aria-valuemax="1" aria-valuenow="1">
      <span class="telemetry-fill"></span>
    </cr-art-ds-meter>
    <span class="visually-hidden" aria-live="polite" data-field="boss-announce"></span>`;
  const name = element.querySelector<HTMLElement>('[data-field="boss-name"]')!;
  const meter = element.querySelector<HTMLElement>('cr-art-ds-meter')!;
  const fill = element.querySelector<HTMLElement>('.telemetry-fill')!;
  const announce = element.querySelector<HTMLElement>('[data-field="boss-announce"]')!;
  let shown = '';

  return {
    element,
    update(boss) {
      const model = bossBarModel(boss);
      if (element.hidden === model.visible) element.hidden = !model.visible;
      if (!model.visible) return;
      const key = `${model.name}:${model.hp}/${model.maxHp}`;
      if (key === shown) return;
      shown = key;
      name.textContent = model.name;
      meter.setAttribute('aria-valuenow', String(model.value));
      meter.setAttribute('aria-valuetext', model.valueText);
      fill.style.transform = `scaleX(${model.value})`;
      announce.textContent = `${t('ui.hud.boss.label')}, ${model.valueText}`;
    },
  };
}
